<template>
  <div class="container">
    <div>
      <div class="title">
        <p>必备品/排面数配置</p>
        <div class="handle-box">
          <el-button type="primary" plain size="medium" @click="isShowShelfEssential = true" v-if="type !== 'view'">新增</el-button>
        </div>
      </div>
      <div class="content" v-if="selectDataList.length">
        <div class="item-title">
          <el-row type="flex" align="middle" justify="center">
            <el-col :span="type === 'view' ? 3 : 2">序号</el-col>
            <el-col :span="type === 'view' ? 4 : 4">套餐名称</el-col>
            <el-col :span="type === 'view' ? 17 : 15">
              <el-row>
                <el-col :span="4">品牌</el-col>
                <el-col :span="4">子品牌</el-col>
                <el-col :span="4">容量</el-col>
                <el-col :span="3">是否多联包</el-col>
                <el-col :span="3">规格</el-col>
                <el-col :span="3">最小陈列件</el-col>
                <el-col :span="3">排面数</el-col>
              </el-row>
            </el-col>
            <el-col :span="2" v-if="type !== 'view'">操作</el-col>
          </el-row>
        </div>
        <el-row type="flex" align="middle" justify="center" class="item" v-for="item  in selectedDataCurrentList" :key="item.defineName">
          <el-col :span="type === 'view' ? 3 : 2">{{item.sequenceFlag}}</el-col>
          <el-col :span="type === 'view' ? 4 : 4">
            <el-input v-model="item.defineName" disabled></el-input>
          </el-col>
          <el-col :span="type === 'view' ? 17 : 15" class="detail">
            <el-row class="detail-item" v-for="detailItem ,index in item.tradePerfectScopeDetailList" :key="index">
              <el-col :span="4">
                <el-input v-model="detailItem.brandName" disabled></el-input>
              </el-col>
              <el-col :span="4">
                <el-input v-model="detailItem.subBrandName" disabled></el-input>
              </el-col>
              <el-col :span="4">
                <el-input v-model="detailItem.volume" disabled></el-input>
              </el-col>
              <el-col :span="3">
                <el-input v-if="detailItem.multiPackFlag === '1'" disabled placeholder="是"></el-input>
                <el-input v-else disabled placeholder="否"></el-input>
              </el-col>
              <el-col :span="3">
                <el-input v-model="detailItem.multiPackSpec" disabled></el-input>
              </el-col>
              <el-col :span="3">
                <el-input v-model="detailItem.minDisplayQty" disabled></el-input>
              </el-col>
              <el-col :span="3">{{detailItem.rowQty}}</el-col>
            </el-row>
          </el-col>
          <el-col :span="2" v-if="type !== 'view'">
            <el-button type="danger" plain size="medium" @click="remove(item.scopeDefineId)" :disabled="disabled">移除</el-button>
          </el-col>
        </el-row>
      </div>
      <div style="text-align:center;padding:50px 0 60px" v-else>您暂未选择必备品套餐</div>
      <div class="pagination" v-if="selectDataList.length">
        <el-pagination
          background
          :current-page.sync="selectPageInfo.currentPage"
          :page-size="selectPageInfo.pageSize"
          layout="total, prev, pager, next"
          :total="selectDataList.length"
          @current-change="getSelectedDataCurrentList"
        ></el-pagination>
      </div>

      <el-dialog
        :visible="isShowShelfEssential"
        title="选择必备品/排面数配置"
        width="75%"
        :show-close="false"
        style="  min-width: 1500px;"
        class="shelf-dialog"
      >
        <div class="addshelf-search">
          <el-input v-model="searchForm.name" clearable placeholder="套餐名称" />
          <el-select v-model="searchForm.subBrand" clearable placeholder="子品牌">
            <el-option :label="subBrand" :value="subBrand" v-for="(subBrand,index) in subBrandList" :key="index"></el-option>
          </el-select>
          <el-button class="btn-red" @click="search">搜索</el-button>
          <el-button class="btn-reset" @click="reset">重置</el-button>
        </div>
        <div class="content" v-if="currentList.length">
          <template>
            <div class="item-title">
              <el-row type="flex" align="middle" justify="center">
                <el-col :span="2">序号</el-col>
                <el-col :span="4">套餐名称</el-col>
                <el-col :span="15">
                  <el-row>
                    <el-col :span="4">品牌</el-col>
                    <el-col :span="4">子品牌</el-col>
                    <el-col :span="4">容量</el-col>
                    <el-col :span="3">是否多联包</el-col>
                    <el-col :span="3">规格</el-col>
                    <el-col :span="3">最小陈列件</el-col>
                    <el-col :span="3">排面数</el-col>
                  </el-row>
                </el-col>
                <el-col v-if="type === 'add'" :span="2">
                  <el-checkbox v-model="allSelectList[pageInfo.currentPage-1]" @change="handleCheckAllChange">全选</el-checkbox>
                </el-col>
                <el-col v-else :span="2">操作</el-col>
              </el-row>
            </div>
            <el-row type="flex" align="middle" justify="center" class="item" v-for="item  in currentList" :key="item.defineName">
              <el-col :span="2">{{item.sequenceFlag}}</el-col>
              <el-col :span="4">
                <el-input v-model="item.defineName" disabled></el-input>
              </el-col>
              <el-col :span="15" class="detail">
                <el-row class="detail-item" v-for="detailItem ,index in item.tradePerfectScopeDetailList" :key="index">
                  <el-col :span="4">
                    <el-input v-model="detailItem.brandName" disabled></el-input>
                  </el-col>
                  <el-col :span="4">
                    <el-input v-model="detailItem.subBrandName" disabled></el-input>
                  </el-col>
                  <el-col :span="4">
                    <el-input v-model="detailItem.volume" disabled></el-input>
                  </el-col>
                  <el-col :span="3">
                    <el-input v-if="detailItem.multiPackFlag === '1'" disabled placeholder="是"></el-input>
                    <el-input v-else disabled placeholder="否"></el-input>
                  </el-col>
                  <el-col :span="3">
                    <el-input v-model="detailItem.multiPackSpec" disabled></el-input>
                  </el-col>
                  <el-col :span="3">
                    <el-input v-model="detailItem.minDisplayQty" disabled></el-input>
                  </el-col>
                  <el-col :span="3">{{detailItem.rowQty}}</el-col>
                </el-row>
              </el-col>
              <el-col :span="2">
                <el-checkbox v-model="item.checked" @change="val=>handleCheckChange(val,item.scopeDefineId)"></el-checkbox>
              </el-col>
            </el-row>
          </template>
        </div>
        <div style="text-align:center;padding:50px 0 60px" v-else>暂无必备品信息</div>
        <div class="pagination" v-if="currentList.length">
          <el-pagination
            background
            :current-page.sync="pageInfo.currentPage"
            :page-size="pageInfo.pageSize"
            layout="total, prev, pager, next"
            :total="tmpDataList.length"
            @current-change="getCurrentList"
          ></el-pagination>
        </div>
        <div v-if="type === 'add'" class="add-handle">
          <el-button @click="isShowShelfEssential = false">取消</el-button>
          <el-button @click="closeShelfEssential(1)" class="btn-red">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'remove'
    },
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    selectedData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    disabled () {
      return this.type === 'view'
    }
  },
  data () {
    return {
      input: '常用套餐1',
      searchForm: {
        name: '',
        subBrand: ''
      },
      selectPageInfo: {
        currentPage: 1,
        pageSize: 5,
        total: 0
      },
      pageInfo: {
        currentPage: 1,
        pageSize: 5,
        total: 0
      },
      checkAll: false,
      subBrandList: [],
      selectedList: [],
      currentList: [],
      allSelectList: [],
      isShowShelfEssential: false,
      selectDataList: [],
      selectedDataCurrentList: [],
      tmpDataList: []
    }
  },
  created () {
    this.getCurrentList()
    if (this.selectedData) {
      this.copyInit()
    }
  },
  watch: {
    dataList () {
      if (!this.dataList) {
        return
      }
      // this.pageInfo.total = this.dataList.length
      this.tmpDataList = this.dataList
      // this.selectDataList = []
      this.getCurrentList()
      this.getSubBrand()
      this.getSelectedDataCurrentList()
      this.addCheckbox()
    },
    selectedData () {
      if (!this.selectedData) {
        return
      }
      this.copyInit()
    }
  },
  methods: {
    copyInit () {
      this.selectDataList = this.selectedData
      this.getSelectedDataCurrentList()
      let list = []
      this.selectDataList.forEach(item => {
        list.push(item.scopeDefineId)
        this.dataList.forEach(dataListItem => {
          if (item.scopeDefineId === dataListItem.scopeDefineId) {
            this.$set(dataListItem, 'checked', true)
          }
        })
      })
      this.checkCheckAll()
      this.selectedList = list
    },
    // 获取子品牌列表
    getSubBrand () {
      this.subBrandList = []
      this.dataList.forEach(dataItem => {
        dataItem.tradePerfectScopeDetailList.forEach(item => {
          this.subBrandList.push(item.subBrandName)
        })
      })
      this.subBrandList = [...new Set(this.subBrandList)]
    },
    // 添加checked属性 记录选择框状态
    addCheckbox () {
      this.dataList.forEach(item => {
        this.$set(item, 'checked', false)
        this.allSelectList.push(false)
      })
    },
    // 获取当前分页列表
    getCurrentList () {
      let startIndex = this.pageInfo.pageSize * (this.pageInfo.currentPage - 1)
      let endIndex = this.pageInfo.pageSize * this.pageInfo.currentPage
      this.currentList = this.tmpDataList.slice(startIndex, endIndex)
      this.checkCheckAll()
    },
    // 全选按钮
    handleCheckAllChange (val) {
      if (val) {
        this.currentList.forEach(item => {
          item.checked = true
          this.selectedList.push(item.scopeDefineId)
          this.selectedList = [...new Set(this.selectedList)]
        })
      } else {
        this.currentList.forEach(item => {
          item.checked = false
          let index = this.selectedList.findIndex((selectItem) => {
            return selectItem === item.scopeDefineId
          })
          this.selectedList.splice(index, 1)
        })
      }
    },
    checkCheckAll () {
      // 当前页面全选 全选按钮为选中状态
      if (this.currentList.every(item => {
        return item.checked === true
      })) {
        this.allSelectList[this.pageInfo.currentPage - 1] = true
      } else {
        this.allSelectList[this.pageInfo.currentPage - 1] = false
      }
    },
    // checkbox 选中处理
    handleCheckChange (val, scopeDefineId) {
      if (val) {
        this.selectedList.push(scopeDefineId)
      } else {
        let index = this.selectedList.findIndex((item) => {
          return item === scopeDefineId
        })
        this.selectedList.splice(index, 1)
      }
      this.checkCheckAll()
    },
    // 关闭dialog
    closeShelfEssential (val) {
      if (val === 1) {
        this.selectDataList = this.dataList.filter(item => {
          for (let i = 0; i < this.selectedList.length; i++) {
            if (item.scopeDefineId === this.selectedList[i]) {
              return item
            }
          }
        })
        this.getSelectedDataCurrentList()
      }
      this.isShowShelfEssential = false
    },
    remove (val) {
      let index = this.selectDataList.findIndex(item => {
        return item.scopeDefineId === val
      })
      this.selectDataList.splice(index, 1)
      this.getSelectedDataCurrentList()
      this.selectedList.splice(this.selectedList.findIndex(item => {
        return item === val
      }), 1)
      if (this.selectedList.length) {
        this.dataList.forEach(item => {
          for (let i = 0; i < this.selectedList.length; i++) {
            if (item.scopeDefineId === this.selectedList[i]) {
              this.$set(item, 'checked', true)
              break
            } else {
              this.$set(item, 'checked', false)
            }
          }
        })
      } else {
        this.dataList.forEach(item => {
          item.checked = false
        })
      }
      this.getCurrentList()
      this.checkCheckAll()
    },
    getSelectedDataCurrentList () {
      let startIndex = this.selectPageInfo.pageSize * (this.selectPageInfo.currentPage - 1)
      let endIndex = this.selectPageInfo.pageSize * this.selectPageInfo.currentPage
      this.selectedDataCurrentList = this.selectDataList.slice(startIndex, endIndex)
      if (!this.selectedDataCurrentList.length && this.selectPageInfo.currentPage !== 1) {
        this.selectPageInfo.currentPage = this.selectPageInfo.currentPage - 1
        this.getSelectedDataCurrentList()
      }
    },
    // 搜索
    search () {
      this.tmpDataList = this.dataList.filter(item => {
        let canReturn = true
        if (this.searchForm.name) {
          canReturn = canReturn && item.defineName.toLowerCase().indexOf(this.searchForm.name.toLowerCase()) !== -1
        }
        if (this.searchForm.subBrand) {
          canReturn = canReturn && item.tradePerfectScopeDetailList.some(detailItem => {
            if (detailItem.subBrandName === this.searchForm.subBrand) {
              return true
            }
          })
        }
        return canReturn
      })
      this.pageInfo.currentPage = 1
      this.getCurrentList()
      this.checkCheckAll()
    },
    reset () {
      this.searchForm = this.$options.data().searchForm
      this.search()
    },
    resetData () {
      this.selectedList = []
      this.selectDataList = []
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-checkbox__inner {
  width: 30px;
  height: 30px;
}
::v-deep .el-checkbox__inner::after {
  width: 10px;
  height: 19px;
  border: 3px solid #fff;
  border-left: 0;
  border-top: 0;
  left: 7px;
  top: -1px;
}
.container {
  background-color: #fff;
  // padding: 20px;
}
.content {
  border-bottom: 1px solid #cccccc;
  padding: 20px;
}
.item-title {
  line-height: 40px;
  font-size: 14px;
  text-align: center;
  background-color: #f5f5f5;
}
.item {
  display: flex;
  align-items: center;
  text-align: center;
  padding: 20px 0;
  .el-input {
    width: 80%;
  }
  .detail {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .el-input {
      width: 80%;
      height: 30px;
    }
    &::v-deep .el-input__inner {
      height: 30px;
    }
    .detail-item {
      padding: 15px 0;
      width: 100%;
      display: flex;
      align-items: center;
    }
  }
}
.pagination {
  text-align: center;
  padding: 20px 0;
}
.add-handle {
  width: 300px;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
}
.el-button {
  width: 80px;
  height: 30px;
  padding: 0 20px;
}
.addshelf-search {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .el-input {
    width: 150px;
    margin-left: 20px;
    margin-right: 10px;
    &::v-deep .el-input__inner {
      height: 30px;
    }
  }
  .el-select {
    width: 150px;
    margin-right: 10px;
    &::v-deep .el-input__inner {
      height: 30px;
    }
  }
  ::v-deep .el-input__icon {
    line-height: 30px;
  }
  .el-button {
    height: 30px;
    padding: 0 20px;
  }
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  padding: 20px 20px 0;
  .handle-box {
    // margin-right: 10px;
    .el-button {
      width: 80px;
      height: 30px;
      padding: 0 20px;
    }
  }
  p {
    font-weight: 700;
    margin: 0;
  }
  .el-button {
    width: 80px;
  }
}
.btn-reset {
  background-color: #bbb;
  color: #ffffff;
}
</style>
